import { Theme, alpha } from '@mui/material';

export default {
    container: {
        mx: 'auto',
        width: '100%',
        maxWidth: '744px',
        p: 3,
        borderRadius: '3px',
        border: (theme: Theme) => `1px solid ${alpha(theme.palette.text.primary, 0.08)}`,
        background: 'background.default',
        boxShadow: (theme: Theme) => `0px 8px 24px 0px ${alpha(theme.palette.text.primary, 0.08)}`,
    },
    dataWrapper: {},
    messageContainer: {},
    title: {
        fontSize: '20px',
        fontWeight: 600,
        lineHeight: 1.3,
    },
    message: {
        fontSize: '14px',
    },
    supportAdminsContainer: {},
    supportAdminsIconHolder: {
        fontSize: '16px',
        height: '18px',
        display: 'inline-flex',
        alignItems: 'center',
        mr: 1,
    },
    buttonsContainer: {
        pt: 1,
    },
    iconHolder: {
        flexShrink: 0,
        ml: 3,
        display: 'inline-flex',
        alignItems: 'center',
        color: 'primary.main',
    },
};
